import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Manifesto", href: "#manifesto" },
  { label: "Services", href: "#services" },
  { label: "Exposed", href: "#exposed" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-200 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
        >
          <span className="relative inline-flex h-2.5 w-2.5">
            <span className="absolute inset-0 bg-red-500 pulse-dot" />
            <span className="absolute inset-0 bg-red-500 rounded-none" />
          </span>
          <span className="font-mono text-xs md:text-sm tracking-[0.28em] uppercase text-white">
            High-Risk<span className="text-red-500">/</span>Algorithms
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.22em] text-gray-300 hover:text-white link-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="cta-book-consult"
          className="hidden md:inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-white transition-colors"
        >
          Book Consult
          <span aria-hidden>→</span>
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mnav-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.22em] text-gray-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mcta-book-consult"
              className="bg-red-600 px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-white text-center"
            >
              Book Consult
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
